import styled from 'styled-components';
import tinycolor from 'tinycolor2';

/**
 * Kiosk Pro breakpoints - optimized for kiosk hardware
 */
const KIOSK_PRO_LANDSCAPE_BREAKPOINT = 1510;
const KIOSK_PRO_PORTRAIT_BREAKPOINT = 720;

export const KIOSK_PRO_MEDIA = {
  maxWidth: `only screen and (max-width: ${KIOSK_PRO_LANDSCAPE_BREAKPOINT}px)`,
  landscapeMaxWidth: `only screen and (orientation: landscape) and (max-width: ${KIOSK_PRO_LANDSCAPE_BREAKPOINT}px)`,
  portraitMaxWidth: `only screen and (orientation: portrait) and (max-width: ${KIOSK_PRO_PORTRAIT_BREAKPOINT}px)`,
};

export const PageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  min-height: 100dvh;
  max-width: 1600px;
  margin: 0 auto;
  place-items: center;
  text-align: center;

  @media (orientation: landscape) {
    grid-template-columns: minmax(340px, auto) 1fr;
    min-height: 100dvh;
    gap: 2rem;
  }
`;

export const PageContainerBackground = styled.div`
  background-color: ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 24px;
  min-height: 100dvh;

  @media (orientation: landscape) {
    min-height: 100dvh;
  }
`;

export const LoginOptionsContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 179px 72px;
  width: 100%;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    padding: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 56px;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1000px;
  padding: 40px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: clamp(46px, 11.46vw, 56px);
  margin: 0 0 72px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 40px;
    margin-bottom: 56px;
  }

  @media (orientation: portrait) {
    font-size: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 40px;
    margin-bottom: 56px;
  }
`;

export const Subtitle = styled.p`
  font-size: clamp(24px, 3vw, 36px);
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.maxWidth} {
    font-size: clamp(26px, 11.46vw, 28px);
  }
`;
